import { useQuery } from '@apollo/client';
import {
  Alert,
  AlertDescription,
  AlertIcon,
  Button,
  Flex,
  Spinner,
} from '@chakra-ui/react';
import { FC } from 'react';
import { GET_RECOMMENDATION_SHOWCASE } from '../../../graphQL/queries';
import { ContextoVitrine, VitrineRecomendacao } from '../types';
import ShowcaseForm from './ShowcaseForm';

interface Props {
  contexto: ContextoVitrine;
}

/** Carrega a vitrine de um contexto e trata carregamento, erro e vitrine não cadastrada. */
const ShowcaseTab: FC<Props> = ({ contexto }) => {
  const { data, loading, error, refetch } = useQuery<{
    recommendationShowcase: VitrineRecomendacao | null;
  }>(GET_RECOMMENDATION_SHOWCASE, {
    variables: { context: contexto },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });

  if (loading && !data) {
    return (
      <Flex justify="center" py={16}>
        <Spinner color="brand.500" size="xl" />
      </Flex>
    );
  }

  if (error && !data) {
    return (
      <Alert status="error" borderRadius="12px">
        <AlertIcon />
        <AlertDescription flex={1}>
          {error.message || 'Não foi possível carregar a vitrine.'}
        </AlertDescription>
        <Button size="sm" onClick={() => refetch()}>
          Tentar de novo
        </Button>
      </Alert>
    );
  }

  const vitrine = data?.recommendationShowcase;

  if (!vitrine) {
    return (
      <Alert status="warning" borderRadius="12px">
        <AlertIcon />
        <AlertDescription>
          Vitrine não cadastrada neste ambiente. Peça para rodar o script de
          seed do cms-api.
        </AlertDescription>
      </Alert>
    );
  }

  return <ShowcaseForm vitrine={vitrine} />;
};

export default ShowcaseTab;
